/**
 * Renders a live image from ImageDetails.js
 *      - wrapper class
 * Rendered in ImageGrid.js
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Permissions from '../../../data/permissions';
import ImageDetails from './ImageDetails';


class SnapShotItem extends React.Component {

    render() {
        return (<ImageDetails {...this.props} />);
    }
}

SnapShotItem.propTypes = {
    features: PropTypes.shape({
        debug: PropTypes.bool,
        media_request: PropTypes.bool,
    }).isRequired,
    stage: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,

    selectedRaven: PropTypes.shape({
        ravenUuid: PropTypes.string.isRequired,
        noServicePlan: PropTypes.bool,
        dashboard: PropTypes.shape({
            events: PropTypes.arrayOf(PropTypes.object)
        })
    }),
    mqttService: PropTypes.object,
    unitOfMeasure: PropTypes.string.isRequired,
}


const mapStateToProps = state => {
    return {
    };
};

export default connect(mapStateToProps)(SnapShotItem);